export default "__VITE_ASSET__ZEcIiyAa__"